
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React, { Fragment } from 'react';
import styled from '@emotion/styled';
import Link from 'next/link';
import { useRouter } from 'next/router';
import useTranslation from 'next-translate/useTranslation';
import widgetRoutes from 'enums/routes';
import { Active_Schedulables } from 'shared/presenters/graphqlTypes';
import { OutletPresenter, SchedulablePresenter } from 'shared/presenters';
import { RecursivePartial, definedNotNull } from 'shared/presenters/presenter';
import translateChargeableTitle from 'helpers/translateChargeableTitle';
import { TopLevelCard } from 'helpers/determineTopLevelChargeableData';
import useStoreMarketplaceReferrals from 'state/useStoreMarketplaceReferrals';
import { arrayToString, stripHTMLTags, truncateString } from 'shared/helpers/stringUtilities';
import CoverImage from 'library/atoms/CoverImage';
import GoogleStructuredDataBreadcrumb from 'library/molecules/GoogleStructuredData/GoogleStructuredDataBreadcrumbs';
import HeadContainer from 'library/atoms/HeadContainer';
import Header from 'library/molecules/Header';
import Icon from 'shared/library/atoms/Icon';
import Item, { ItemUl } from 'library/molecules/Item';
import OutletSidebar from 'library/organisms/OutletSidebar';
import { H4, Text } from 'library/atoms/Typography';
import { LayoutWithSidebar } from 'library/atoms/Layout';
import AboutEola from 'library/atoms/AboutEola';
interface HomeCard extends Omit<TopLevelCard, 'schedulable'> {
    schedulable: SchedulablePresenter;
}
interface HomeProps {
    cards: HomeCard[];
    outlet: OutletPresenter;
}
const Home = ({ cards, outlet }: HomeProps) => {
    const { t } = useTranslation('common');
    const { query } = useRouter();
    const widgetSlug = query.widgetSlug as string;
    const metaDescription = outlet.description()
        ? truncateString(stripHTMLTags(outlet.description()), 200)
        : t(outlet?.address?.city
            ? 'meta-description-with-location'
            : 'meta-description-without-location', {
            outlet: outlet.name,
            location: outlet?.address?.city,
            activities: outlet.active_schedulables
                ? arrayToString(outlet?.active_schedulables.map((s: RecursivePartial<Active_Schedulables>) => definedNotNull(definedNotNull(s.activity_type).name)))
                : t('common:activities').toLowerCase()
        });
    // Store marketplace source for session if utm set
    useStoreMarketplaceReferrals();
    return (<>
      <LayoutWithSidebar head={<HeadContainer title={`${outlet.name} - ${t('book-now')}`} description={metaDescription}>
            {!outlet.feature_toggles?.marketplace_enabled ||
                (outlet.admin_forced_marketplace_disable && (<meta name="robots" content="noindex"/>))}
          </HeadContainer>} header={<Header />} sidebar={<OutletSidebar outlet={outlet}/>}>
        <>
          <CardContainer as="div">
            {cards?.map(card => {
            return (<Fragment key={card.title}>
                  <StyledLink href={card.href}>
                    <Item variant="slimCard" title={translateChargeableTitle(card.title, t)}>
                      <ThumbnailCoverImage src={card.cardImage} variant="thumb"/>
                      <StyledItemTextCta>
                        <H4>{translateChargeableTitle(card.title, t)}</H4>
                        <Text fontStyle="p3" color="secondary">
                          {card.text}
                        </Text>
                      </StyledItemTextCta>
                      <Icon name="card-arrow" size={24}/>
                    </Item>
                  </StyledLink>
                </Fragment>);
        })}
          </CardContainer>

          <AboutEola outlet={outlet}/>
          <GoogleStructuredDataBreadcrumb breadcrumbs={[
            {
                link: widgetRoutes.HOME.url({ widgetSlug: widgetSlug }),
                name: definedNotNull(outlet.name),
                image: outlet.logoImageURL()
            }
        ]}/>
        </>
      </LayoutWithSidebar>
    </>);
};
export default Home;
const StyledLink = styled(Link)(() => ({
    textDecoration: 'none',
    display: 'block',
    width: '100%'
}));
const StyledItemTextCta = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    padding: `${theme.space[3]}px ${theme.space[4]}px ${theme.space[3]}px ${theme.space[4]}px`,
    maxHeight: '136px',
    '& p': {
        ...theme.mixins.ellipsisLineClamp(4)
    },
    [theme.mediaQueries.md]: {
        maxHeight: '180px',
        '& p': {
            ...theme.mixins.ellipsisLineClamp(6)
        }
    }
}));
const ThumbnailCoverImage = styled(CoverImage)(({ theme }) => ({
    height: '136px',
    width: '136px',
    marginBottom: '0px',
    borderRadius: `${theme.radii[2]}px ${theme.radii[0]}px ${theme.radii[0]}px ${theme.radii[2]}px`,
    [theme.mediaQueries.md]: {
        height: '180px',
        width: '180px'
    }
}));
const CardContainer = styled(ItemUl)(({ theme }) => ({
    marginTop: `0`,
    paddingTop: 0,
    [theme.mediaQueries.lg]: {
        maxWidth: '560px',
        marginTop: `${theme.space[4]}px`,
        marginLeft: `auto`,
        marginRight: `auto`
    }
}));

    async function __Next_Translate__getStaticProps__19a4e7eeb8b__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'library//Home/Home',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__19a4e7eeb8b__ as getStaticProps }
  